export default __webpack_public_path__ + "static/media/hat-school.b6464dca.svg";